const createMessageSigner = ({ passkey, addressProvider }) => {
    const signMessage = async ({ assetName, message }) => {
        const { address } = await addressProvider.getReceiveAddress({
            assetName,
        });
        const data = await passkey.signMessage({
            address,
            expectedAddress: address,
            baseAssetName: assetName,
            message,
        });
        if (!data || data.error) {
            throw new Error(data?.error ?? 'The signer rejected the request.');
        }
        return data;
    };
    return {
        signMessage,
    };
};
const messageSignerDefinition = {
    id: 'messageSigner',
    type: 'module',
    factory: createMessageSigner,
    public: true,
    dependencies: ['passkey', 'addressProvider'],
};
export default messageSignerDefinition;
